import { render, staticRenderFns } from "./QuestionTaskForm.vue?vue&type=template&id=6acac0c3&scoped=true"
import script from "./QuestionTaskForm.vue?vue&type=script&lang=js"
export * from "./QuestionTaskForm.vue?vue&type=script&lang=js"
import style0 from "./QuestionTaskForm.vue?vue&type=style&index=0&id=6acac0c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acac0c3",
  null
  
)

export default component.exports